<div class="dialog-header flex align-items-center justify-content-between w-full">
  <h2>Editează utilizator API</h2>
  <p-button
    mat-dialog-close
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content>
  <form [formGroup]="userForm" class="grid grid-nogutter gap-2">
    <div class="col-12">
      <span class="block font-bold mb-1">Rol</span>
      <p-dropdown
        optionLabel="roleName"
        optionValue="roleName"
        styleClass="w-full"
        placeholder="Selectati un rol"
        formControlName="role"
        [options]="roles()"
        [loading]="!roles()"
      ></p-dropdown>
    </div>

    <div class="col-12">
      <span class="block font-bold mb-1">Extensii rol</span>
      @if (showOldExtensions()) {
        @if (oldRoleExtensions().length > 0) {
          <p class="text-xs text-gray-600 m-0">
            <b>
              Extensii actuale: {{ mapRoleExtensions(oldRoleExtensions()) }}
            </b>
          </p>
        }
      }
      <p-multiSelect
        optionValue="value"
        optionLabel="label"
        optionDisabled="disabled"
        styleClass="w-full"
        placeholder="Extindeți drepturile utilizatorului"
        formControlName="roleExtensions"
        appendTo="body"
        [options]="roleExtensions()"
        [loading]="!roles()"
        [showToggleAll]="false"
        (onChange)="roleExtensionsChanged($event)"
      >
        <ng-template pTemplate="item" let-extension>
          {{ $any(roleExtensionsMapping())[extension.value] }}
        </ng-template>
      </p-multiSelect>
    </div>

    <div class="col-12">
      <span class="font-bold block mb-1">Zonă</span>
      <p-dropdown
        formControlName="zoneId"
        optionLabel="name"
        optionValue="id"
        placeholder="Selectează o zonă"
        styleClass="w-full"
        appendTo="body"
        filterBy="name"
        [filter]="true"
        [options]="zones()"
        [loading]="!zonesFetched()"
      />
      @let zone = userForm.get("zoneId");
      @let zoneErrors = zone?.errors;
      @if (zone?.dirty) {
        @if (zoneErrors?.["minlength"]) {
          <small class="text-red-500">Vă rugăm să selectați zona de acces</small>
        }
      }
    </div>

    <div class="col-12">
      <span class="font-bold block mb-1">Descriere</span>
      <textarea
        class="w-full"
        rows="5"
        cols="30"
        pInputTextarea
        formControlName="description"
      ></textarea>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    pButton
    class="w-full"
    label="Salvează"
    [disabled]="!userForm.valid"
    (click)="saveUser()"
  ></button>
</mat-dialog-actions>
@if (apiUserCreateStatus() === "creating") {
  <div class="blurred-div">
    <p-progressSpinner class="blurred-div-spinner"></p-progressSpinner>
  </div>
}
